// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 326 ? "f70991a6" : chunkId) + "." + {"326":"9c0f95947f7030a296f6","911":"637ba6c8aae19a80a812"}[chunkId] + ".js";
};